import React from 'react';
import type { Label as LabelType } from 'root/apiTypes';
import { Label } from 'root/components/Menus/Label/Label';
import { classes } from './Labels.st.css';

export const Labels = ({ labels, 'data-hook': dataHook }: { labels: LabelType[]; 'data-hook'?: string }) => {
  return (
    <div className={classes.labels} data-hook={dataHook} role="list">
      {labels.map((label) => (
        <Label key={label.id} label={label} />
      ))}
    </div>
  );
};
